import styled from "styled-components";

export const FancyButton = styled.button`
  background-color: transparent;
  color: white;
  border: 2px solid #a2a087;

  padding: 5px 30px;

  font-family: "Open Sans", sans-serif;

  font-style: normal;
  font-weight: 300;

  line-height: 41px;
  text-align: center;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  cursor: pointer;
`;
